<template>
  <li class="v-item" :class="[
    `-${ photoMode }_photo`,
    `-bg_${ bgMode }`,
    `-ring_category_id_${ r.ring_category_id }`,
    photoMode == 'main' && this.$route.query.photoMode ? `-transparent_bg_photo` : '',
    r.show_as_wide == true ? `-showAsWide` : ''
    ]" :data-test="getProductBackgroundsInOrder(index)">
    <a class="v-anchor" :href="r.show_url" :title="$t('RingItem.urlTitle', { ringName: r.name })">
<!--
      <div class="v-itemBg" v-if="bgMode == 'random' || this.$route.query.photoMode == 'random'">
        <img :src="productBackgrounds[`${ getProductBackgroundsRandom() }`]">
      </div>
      <div class="v-itemBg" v-else-if="bgMode == 'in_order' || this.$route.query.photoMode == 'in_order'">
        <img :src="productBackgrounds[`${ getProductBackgroundsInOrder(index) }`]">
      </div>
      <div class="v-itemBg" v-else-if="this.$route.query.photoMode">
        <img v-if="photoMode == 'main' && (!['/set_rings'].includes($pathname)) && productBackgrounds[`${ this.$route.query.photoMode }`] " :src="productBackgrounds[`${ this.$route.query.photoMode }`]">
      </div>
      <div class="v-itemBg" v-else-if="bgMode != ''">
        <img :src="productBackgrounds[`${ bgMode }`]">
      </div>
-->
      <div class="v-itemImg">
        <picture>
          <!--
          <img v-if="(!['/set_rings'].includes($pathname)) && photoMode == 'main' && this.$route.query.photoMode" :src="r[`single_color_bg_photo`]" :alt="r.name">
          <img v-else :src="r[`${ photoMode }_photo`]" :alt="r.name">
          -->
          <img :src="getPhoto(r)" :alt="r.name">
        </picture>
      </div>
      <div class="v-inner">
        <h3 class="v-name">{{ r.name }}</h3>
        <p v-show="r.least_price" class="v-price">{{ r.least_price }}</p>
        <div aria-hidden="true" v-show="r.catch_phrase" class="v-catchPhrase">{{ r.catch_phrase }}</div>
      </div>
      <div v-if="r.new_flag" class="v-new">NEW</div>
    </a>

    <!--
    <template v-if="r.class_name === 'Ring'">
      <div
        v-show="!isFavoritedLoading"
        class="v-favorite"
        :title="[
          favoritedRings.includes(r.id) ? `${r.name}をお気に入りから削除する` : `${r.name}をお気に入りに登録する`
        ]"
        @click.stop="$emit('favoriteClick', $event, r)"
        :data-is-liked="[
          favoritedRings.includes(r.id) ? `true` : `false`
        ]"
      >
        <svg width="19.37" height="14.565" viewBox="-2 -2 40.74 31.13">
          <g>
            <g>
              <path d="M19.83,25c-2.1,2-3.67,3.48-3.67,3.48S5.93,18.94,2.55,14.76C-4.11,6.53,6.79-5.71,16.16,4.2c9.38-9.91,20.27,2.33,13.61,10.56-1.27,1.56-3.48,3.86-5.76,6.13" fill="none" stroke="#a1a1a1" stroke-miterlimit="10"/>
              <line x1="38.24" y1="23.45" x2="28.24" y2="23.45" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-miterlimit="10"/>
              <line x1="33.24" y1="28.45" x2="33.24" y2="18.45" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-miterlimit="10"/>
            </g>
          </g>
        </svg>
      </div>
    </template>
    -->

    <div class="v-quickview">
      <button type="button" class="v-quickViewButton" @click="$emit('quickViewClick', $event, r)" :title='`${r.name}をクイックビューで見る`'>
        <svg xmlns="http://www.w3.org/2000/svg" height="26px" viewBox="0 -960 960 960" width="26px" fill="#808080"><path d="M765-144 526-384q-30 23-65.79 35.5-35.79 12.5-76.18 12.5Q284-336 214-406t-70-170q0-100 70-170t170-70q100 0 170 70t70 170.03q0 40.39-12.5 76.18Q599-464 577-434l239 239-51 51ZM384-408q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm-36-60v-72h-72v-72h72v-72h72v72h72v72h-72v72h-72Z"/></svg>
      </button>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    r: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    favoritedRings: {
      type: Array,
      default: [],
    },
    isFavoritedLoading: {
      type: Boolean,
      default: true,
    },
    photoMode: {
      type: String,
      required: true,
    },
    bgMode: {
      type: String,
      required: true,
    },
    productBackgrounds: {
      type: Object,
      required: true,
    },
    productBackgroundsRandom: {
      type: Array,
      required: true,
    },
  },

  name: 'RingItem',

  // TODO: lazyload実装（packs/brand/shared/lazyload.jsの内容と同じことをしたい）
  mounted() {
  },
  methods: {
    getPhoto(r) {
      const mainPhotoCategoryIds = [6, 7, 8, 9];
      return mainPhotoCategoryIds.includes(r.ring_category_id) ? r.main_photo : r[`${this.photoMode}_photo`];
    },
    getProductBackgroundsRandom () {
      let array;
      if (this.$route.query.imgArray) {
        array = this.$route.query.imgArray.split('-');
      } else {
        array = this.productBackgroundsRandom;
      }

      const min = 0;
      const max = array.length-1;
      const randomNum = Math.floor(Math.random() * (max + 1 - min)) + min;
      return array[randomNum]
    },
    getProductBackgroundsInOrder (index) {
      let array;
      if (this.$route.query.imgArray) {
        array = this.$route.query.imgArray.split('-');
      } else {
        array = this.productBackgroundsRandom;
      }
      const length = array.length;
      const number = index % length
      return array[number]
    }
  },
}
</script>

<style lang="scss" scoped>
.v-item {
  border: 1px solid #e0e0e0;
  position: relative;
  border-radius: 2px;
  background: #fff;
  transition: .3s background-color;

  @media screen and (min-width: 900px) {
    border-radius: 4px;
  }
  &.-single_color_bg_photo {
    border-width: 0;
    background: #b9d2f0;
  }
  &.-transparent_bg_photo {
    background: transparent;
  }
  &.-ring_category_id_6 {
    border-width: 1px;
    background: #fff;
  }
  &.-showAsWide {
    grid-column: span 2;
  }
}

.v-inner {

}

.v-itemBg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.v-itemImg {
  position: relative;
  height: 0;
  padding-top: 100%;
  overflow: hidden;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: top;
    transition: .5s transform;

    .-hand_photo &,
    .-hand2_photo & {
      object-fit: cover;
    }

    .v-anchor:hover &,
    .v-anchor:active & {
      transform: scale(1.3);
    }
  }

  .-showAsWide & {
    --grid-gap: 10px;
    padding-top: 70%;

    @media screen and (min-width: 600px) {
      padding-top: calc(((100% - var(--grid-gap)) / 2));
    }

    @media screen and (min-width: 900px) {
      --grid-gap: 20px;
    }

    @media screen and (min-width: 1200px) {
      --grid-gap: 30px;
    }
  }
}

.v-anchor {
  text-decoration: none;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover,
  &:active {
    opacity: 1;
  }
}

.v-inner {
  padding: 15px 32px 15px 10px;
  position: relative;
  flex-grow: 1;
  .v-item.-single_color_bg_photo & {
    padding-top: 0;
  }
  .v-item.-transparent_bg_photo & {
    padding-top: 0;
  }
  .v-item.-single_color_bg_photo.-ring_category_id_6 & {
    padding: 15px 32px 15px 10px;
    background: #fff;
  }
}

.v-name {
  font-size: 10px;
  margin: 0 0 5px;
  line-height: 1.2;
  @media screen and (min-width: 900px) {
    font-size: 14px;
  }
}

.v-price {
  font-size: 10px;
  font-family: var(--sans-serif-en);
  margin: 0;
  line-height: 1;
  @media screen and (min-width: 900px) {
    font-size: 12px;
  }
}

.v-catchPhrase {
  font-size: 10px;
  font-family: "Zen Old Mincho", var(--serif);
  margin: 0;
  line-height: 1.4;
  font-feature-settings: "palt";
  display: block;
  @media screen and (min-width: 900px) {
    font-size: 12px;
  }
}

.v-new {
  position: absolute;
  top: 10px;
  left: 10px;
  font-family: var(--sans-serif-en);
  line-height: 1;
  font-size: 10px;
  @media screen and (min-width: 900px) {
    font-size: 14px;
  }
}

.v-favorite {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  transition: .3s transform;

  &:hover {
    transform: scale(1.2);
  }

  svg {
    @media screen and (min-width: 900px) {
      width: 25px;
      height: 25px;
    }
  }

  path {
    transition: .3s stroke;
  }

  line {
    transition: .3s opacity;
  }

  &[data-is-liked="true"] {
    path {
      stroke: #da6f6b;
      stroke-width: 3px;
    }
    line {
      opacity: 0;
    }
  }
}

.v-quickview {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 8px 3px 8px 5px;
  transition: .3s transform;

  svg {
    @media screen and (min-width: 900px) {
      width: 25px;
      height: 25px;
    }
  }

  &:hover {
    transform: scale(1.2);
  }
}

.v-quickViewButton {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  padding: 0;
  outline: 0;
  letter-spacing: inherit;
  text-align: inherit;
}
</style>
